import {useMutation, useQueryClient} from '@tanstack/react-query';

import {createCategory, CreateCategoryParams} from '../api';
import {QUERY__CATEGORIES} from '../queryKeys';

export const useCreateCategory = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: CreateCategoryParams) => createCategory(params),
    onSuccess: () => {
      void queryClient.invalidateQueries({queryKey: [QUERY__CATEGORIES]});
    },
  });
};
